module.exports = __webpack_public_path__ + "img/paqueteria.6bdfa335.svg";